import React from 'react'
import classnames from 'classnames'

export const PieChart = ({
  values = [ 0,0,0,0,0,0,0,0 ],
  className
}) => {

  let max = 0
  // Find the max out of all the slice values
  for (var i = 0; i < values.length; i++) {
    const value = Number(values[i])
    if(value > max) {
      max = value
    }
  }
  // return true if the slice value is equal to max value:
  const isSelected = (index) => (max >0 && values[index] == max)

  const pieSVG = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 133.02 133.02" id="cricket-pie-chart">
      <g>
        <circle class="pie-chart-border" cx="66.51" cy="66.51" r="64.52"></circle>

        <path class="slice ${isSelected(5) ? 'slice--selected' : ''}" d="M20.56,111.87,65.49,67.1H2A63.09,63.09,0,0,0,20.56,111.87Z"></path>
        <path class="pie-chart-border" d="M65.28,130.38h0Z"></path>

        <path class="slice ${isSelected(4) ? 'slice--selected' : ''}" d="M65.95,131l.11-63.44-44.9,44.9A63.09,63.09,0,0,0,65.95,131Z"></path>
        <path class="pie-chart-border" d="M110.65,112.49l.15-.16-.3.3Z"></path>

        <path class="slice ${isSelected(2) ? 'slice--selected' : ''}" d="M112.43,111.87,67.49,67.1H131A63.09,63.09,0,0,1,112.43,111.87Z"></path>

        <path class="slice ${isSelected(3) ? 'slice--selected' : ''}" d="M67,131l-.11-63.44,44.9,44.9A63.09,63.09,0,0,1,67,131Z"></path>
        <path class="pie-chart-border" d="M22.33,112.49l-.15-.16.3.3Z"></path>

        <path class="slice ${isSelected(6) ? 'slice--selected' : ''}" d="M20.56,21.44,65.49,66.22H2A63.09,63.09,0,0,1,20.56,21.44Z"></path>
        <path class="pie-chart-border" d="M65.28,2.94h0Z"></path>

        <path class="slice ${isSelected(7) ? 'slice--selected' : ''}" d="M65.95,2.29l.11,63.44-44.9-44.9A63.09,63.09,0,0,1,65.95,2.29Z"></path>
        <path class="pie-chart-border" d="M110.65,20.83l.15.16-.3-.3Z"></path>

        <path class="slice ${isSelected(1) ? 'slice--selected' : ''}" d="M112.43,21.44,67.49,66.22H131A63.09,63.09,0,0,0,112.43,21.44Z"></path>
        <path class="pie-chart-border" d="M67.71,2.94h0Z"></path>

        <path class="slice ${isSelected(0) ? 'slice--selected' : ''}" d="M67,2.29l-.11,63.44,44.9-44.9A63.09,63.09,0,0,0,67,2.29Z"></path>
        <path class="pie-chart-border" d="M22.33,20.83l-.15.16.3-.3Z"></path>

        <text class="slice-text ${isSelected(7) ? 'slice-text--selected' : ''}" transform="translate(36.32 31.22)">${values[7] || 0}</text>
        <text class="slice-text ${isSelected(0) ? 'slice-text--selected' : ''}" transform="translate(72.32 31.22)">${values[0] || 0}</text>
        <text class="slice-text ${isSelected(1) ? 'slice-text--selected' : ''}" transform="translate(94.65 55.84)">${values[1] || 0}</text>
        <text class="slice-text ${isSelected(6) ? 'slice-text--selected' : ''}" transform="translate(13.44 55.84)">${values[6] || 0}</text>
        <text class="slice-text ${isSelected(5) ? 'slice-text--selected' : ''}" transform="translate(13.44 89.59)">${values[5] || 0}</text>
        <text class="slice-text ${isSelected(4) ? 'slice-text--selected' : ''}" transform="translate(36.32 115.93)">${values[4] || 0}</text>
        <text class="slice-text ${isSelected(3) ? 'slice-text--selected' : ''}" transform="translate(72.32 116.16)">${values[3] || 0}</text>
        <text class="slice-text ${isSelected(2) ? 'slice-text--selected' : ''} " transform="translate(94.65 88.16)">${values[2] || 0}</text>
        <circle class="pie-chart-outline" cx="66.51" cy="66.51" r="64.52"></circle>
      </g>
    </svg>
  `  

  return <div className={classnames('data-vis-col', className)} dangerouslySetInnerHTML={{ __html: pieSVG }} />
} 

export const AthleteJersey = ({
  href = '#',
  className = '',
  styles = '',
  isMedium = false,
  jerseyColor = '',
  trackingName = ''
}) => {
  let jerseySize = isMedium ? 'md' : 'sm' 
  let jerseyFillColor = jerseyColor != '' ? jerseyColor : '#FFF'
  const jerseySVG = `
    <svg style="${styles}" class="jerseySVG ${className}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91.6 91.7"><path  d="M55.8 5.3c-.5 0-1.4-.7-2.2-.8-1.6-.3-3 .2-4.5.2-1.7 0-2.5.2-2.7.3-.2.1-.5.2-.9.2-.8 0-2.1-.3-3.1-.6-.6-.2-1.2-.3-1.5-.3-.7-.1-2.3.4-3.3.6-.6.2-1 .3-1.2.3h-.1c-.8 0-1.3-.8-1.4-1l-.3-.2 1.2-2.5.1-.1C38 .2 42.9 0 45.7 0h.6c1.7 0 7.4.1 9.8 1.4l.1.1 1.1 2.4c.1.1.2.4 0 .8-.3.5-1 .6-1.5.6z"></path><path fill="${jerseyFillColor}" d="M76.3 12.4c-2.5-4.5-6.5-5-10.2-5.5-3.8-.5-11.5-2.6-12-2.8-3.1-1-5.6.2-8.2.2-2.7 0-5.2-1.2-8.2-.2-.5.2-8.3 2.2-12 2.8-3.8.5-7.7 1-10.2 5.5-2.7 4.5-14.4 24.4-14.4 24.4l15.5 7.8 6.1-8.5s1.6 13.7 1.6 20.7-1.9 24.3-.8 30.7c0 0 1.1 3.1 21.3 3.1H47c20.2 0 21.2-3.1 21.2-3.1 1.1-6.4-.6-23.5-.6-30.6s1.5-20.8 1.5-20.8l6 8.4 15.4-7.8c0 .1-11.7-19.8-14.2-24.3z"></path><path fill="#FFF" d="M47 85.4h-2.2c-19.6 0-21.6-2.9-21.8-3.4l1-.4c.1.1 1.9 2.8 20.8 2.8H47c18.8 0 20.6-2.6 20.7-2.7l1 .4c-.2.4-2.1 3.3-21.7 3.3z" opacity=".4"></path><path opacity=".5" fill="none" stroke="#FFF" stroke-width="1.578" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M68.8 36.2s1.7-16.5 4-18.8M23 36.1s-1.7-16.5-4-18.8"></path><path fill="none" stroke="#000" stroke-width="2.158" stroke-linejoin="round" stroke-miterlimit="10" d="M76.3 12.4c-2.5-4.5-6.5-5-10.2-5.5-3.8-.5-11.5-2.6-12-2.8-3.1-1-5.6.2-8.2.2-2.7 0-5.2-1.2-8.2-.2-.5.2-8.3 2.2-12 2.8-3.8.5-7.7 1-10.2 5.5-2.7 4.5-14.4 24.4-14.4 24.4l15.5 7.8 6.1-8.5s1.6 13.7 1.6 20.7-1.9 24.3-.8 30.7c0 0 1.1 3.1 21.3 3.1H47c20.2 0 21.2-3.1 21.2-3.1 1.1-6.4-.6-23.5-.6-30.6s1.5-20.8 1.5-20.8l6 8.4 15.4-7.8c0 .1-11.7-19.8-14.2-24.3z"></path></svg>
  ` 
  return <a name={trackingName} href={href} className={`headshot-jersey-${jerseySize} athlete`} dangerouslySetInnerHTML={{ __html: jerseySVG }} />
}

export const CompareLineGraph = ({
  text = '',
  value = '',
  color1 = '#f2f2f2',
  color2 = '#81B859'
}) => {
  return (
    <div className="compareLineGraph">
        <span className="chartLabel clear">{text}</span>
        <span style={{ backgroundColor: color1 }} className="bar-total">
            <span style={{ backgroundColor: color2, width: value + '%' }} className="bar-percentage"></span>
        </span>
        <span className="chartValue">{value}%</span>
    </div>
  )
}



// WEBPACK FOOTER //
// ../app/components/common/Graphics.jsx